import { Configuration, Logger, LogLevel } from 'msal';

function loggerCallback(logLevel: LogLevel, message: string) {
  //console.log(message);
}

const devTenantConfig = {
  tenant: 'onefscb2ctest.b2clogin.com',
  scopes: ['https://onefscb2ctest.b2clogin.com/gisapp/user_impersonation'],
};

const devAuthConfig: Configuration = {
  auth: {
    clientId: '0d10c5b0-ce2b-421e-bb2e-0b2b2f397e50',
    authority: `https://onefscb2ctest.b2clogin.com/onefscb2ctest.onmicrosoft.com/b2c_1a_fscconnect_openidsignin_dev`,
    redirectUri: window.location.href,
    validateAuthority: true,
    knownAuthorities: [devTenantConfig.tenant],
    postLogoutRedirectUri: 'https://dev-connect.fsc.org/user/logout'
  },
  system: { 
    logger: new Logger(
        loggerCallback , {
          level: LogLevel.Verbose,
          piiLoggingEnabled: true, // if set to true, logs personal and organizational data. By default this is false so that your application doesn't log personal data. Personal data logs are never written to default outputs like Console, Logcat, or NSLog.
        }
    )
  },
  cache: {
    cacheLocation: 'sessionStorage', // Using localstorage to make sure the app is available between tabs
    storeAuthStateInCookie: true, // Needs to be true to for sessionStorage to work
  },
};

const stgTenantConfig = {
  tenant: 'onefscb2ctest.b2clogin.com',
  scopes: ['https://onefscb2ctest.b2clogin.com/gisapp/user_impersonation'],
};

const stgAuthConfig: Configuration = {
  auth: {
    clientId: '0d10c5b0-ce2b-421e-bb2e-0b2b2f397e50',
    authority: `https://onefscb2ctest.b2clogin.com/onefscb2ctest.onmicrosoft.com/b2c_1a_fscconnect_openidsignin_qa`,
    redirectUri: window.location.href,
    validateAuthority: true,
    knownAuthorities: [stgTenantConfig.tenant],
    postLogoutRedirectUri: 'https://qa-connect.fsc.org/user/logout'
  },
  system: { 
    logger: new Logger(
        loggerCallback , {
          level: LogLevel.Warning,
          piiLoggingEnabled: false, // if set to true, logs personal and organizational data. By default this is false so that your application doesn't log personal data. Personal data logs are never written to default outputs like Console, Logcat, or NSLog.
        }
    )
  },
  cache: {
    cacheLocation: 'sessionStorage', // Using localstorage to make sure the app is available between tabs
    storeAuthStateInCookie: true, // Needs to be true to for sessionStorage to work
  },
}; 

const prodTenantConfig = {
  tenant: 'onefscb2c.b2clogin.com',
  scopes: ['https://onefscb2c.onmicrosoft.com/gisapp/user_impersonation'],
};

const prodAuthConfig: Configuration = {
  auth: {
    clientId: 'a080b706-5d11-446e-ad2d-a0504c91db24',
    authority: `https://onefscb2c.b2clogin.com/onefscb2c.onmicrosoft.com/b2c_1a_fscconnect_openidsignin`,
    redirectUri: window.location.href,
    validateAuthority: true,
    knownAuthorities: [prodTenantConfig.tenant],
    postLogoutRedirectUri: 'https://connect.fsc.org/user/logout'
  },
  system: { 
    logger: new Logger(
        loggerCallback , {
          level: LogLevel.Error,
          piiLoggingEnabled: false, // if set to true, logs personal and organizational data. By default this is false so that your application doesn't log personal data. Personal data logs are never written to default outputs like Console, Logcat, or NSLog.
        }
    )
  },
  cache: {
    cacheLocation: 'sessionStorage', // Using localstorage to make sure the app is available between tabs
    storeAuthStateInCookie: true, // Needs to be true to for sessionStorage to work
  },
};

let tConfig, aConfig;

switch (process.env.REACT_APP_ENVIRONMENT) {
  case 'Production':
    tConfig = prodTenantConfig;
    aConfig = prodAuthConfig;
    break;
  case 'Staging':
    tConfig = stgTenantConfig;
    aConfig = stgAuthConfig;
    break
  default:
    tConfig = devTenantConfig;
    aConfig = devAuthConfig;
    break;
}

export const tenantConfig = tConfig;
export const authConfig = aConfig;

export const timeout_initialLimit = 1000 * 60 * 35 // 35 minutes
export const timeout_finalLimit = 1000 * 60 * 5; // 5 minutes

// export const timeout_initialLimit = 1000 * 30 * 1 // 1 minute
// export const timeout_finalLimit = 1000 * 30 * 1; // 30 seconds